export const DEFAULT_SETTINGS = {
  advisorName: "",
  advisorTitle: "",
  advisorEmail: "",
  advisorPhone: "",
  agencyName: "Topsail Travel",
  agencyWebsite: "",
  agencyPhone: "",
  commissionRate: 12,
  agentSplit: 60,
  currency: "USD",
  notifyMessages: true,
  notifyPayments: true,
  notifyDepartures: false,
};

export const ANNOUNCEMENTS = [];

export let CURRENT_CLIENT_ID = null;
export const setCurrentClientId = (id) => {
  CURRENT_CLIENT_ID = id;
};
